/*
 * File: index.tsx
 * Desc: 自定义表单组件
 * File Created: 2019-12-24 11:40:58
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React from 'react';
import { Form, Input } from 'antd';
import { FormBaseProps } from '../form-input';
import { FormProps } from 'antd/lib/form';
import { WrappedFormUtils } from 'antd/lib/form/Form';

interface FormCustomProps extends FormBaseProps, Omit<FormProps, 'onChange'> {
    customRender?: (form?: WrappedFormUtils) => React.ReactNode;
}

const FormCustom = (props: FormCustomProps) => {
    const {
        label,
        labelCol,
        wrapperCol,
        field,
        initialValue,
        required,
        validator,
        form,
        customRender,
    } = props;
    const { getFieldDecorator } = props.form as WrappedFormUtils;
    return (
        <Form.Item
            {...{
                label,
                labelCol,
                wrapperCol,
            }}
            className={props.className}
            style={props.style}
        >
            {getFieldDecorator(field, {
                initialValue,
                rules: [
                    { required, message: `请输入${label}` },
                    {
                        validator: (rule, value, callback) =>
                            validator ? validator(rule, value, callback, form) : callback(),
                    },
                ],
            })(<Input style={{ display: 'none' }} />)}
            {customRender && customRender(props.form)}
        </Form.Item>
    );
};

export default FormCustom;
